import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(/* webpackChunkName: "business-services-youcam-4-google" */ './index')
);

export default prerenderedLoadable(Page);
